import type React from 'react';
import { type IFramework } from '@/framework';
import { LayerType, PluginEnum, type ILayerProps } from '@/version-types';

/** 快捷键功能映射 */
export const SHORTCUT_FUNC_MAP = {
    editText: 'editText',
    brokeGroup: 'brokeGroup',
    makeGroup: 'makeGroup',
    createCopy: 'createCopy',
    textBrush: 'textBrush',
    delete: 'delete',
    more: 'more',
    imageBrush: 'imageBrush',
    ...PluginEnum,
};

/** 按图层类型配置的快捷菜单布局 */
export interface IShortcutMenuLayout {
    /** 上菜单 */
    top?: React.ReactNode;
    /** 右菜单 */
    right?: React.ReactNode;
    /** 下菜单 */
    bottom?: React.ReactNode;
    /** 图层内下菜单 */
    innerBottom?: React.ReactNode;
    /** X 坐标检测距离 */
    detectionX?: number;
    /** Y 坐标检测距离 */
    detectionY?: number;
}

/** 单条默认快捷工具栏项渲染参数 */
export interface IShortcutMenuItemRenderArgs {
    /** 当前操作条所挂主图层 id */
    id: string;
    framework: IFramework;
    /** 主图层（与 shortcut 挂载的 active 一致） */
    layer: ILayerProps;
    /** 当前选中子图层，无则 null */
    activePickLayer: ILayerProps | null;
    /** 是否展示高级 AI 相关入口（含花字、图片 AI） */
    advancedAiEnabled: boolean;
}

/** 默认快捷工具栏项，`sort` 越小越靠前 */
export interface IShortcutMenuItem {
    key: string;
    sort: number;
    /** 返回 null 表示当前场景不展示该项 */
    render: (args: IShortcutMenuItemRenderArgs) => React.ReactNode;
}

/** 业务按图层类型注入的自定义默认工具栏项 */
export interface IShortcutMenuCustomItem {
    layerType: LayerType;
    key: string;
    node: React.ReactNode;
}

export interface IShortcutMenuMouseHandler {
    onMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
    onMouseMove: (event: React.MouseEvent<HTMLDivElement>) => void;
}

/** 无激活图层时渲染的快捷栏扩展 */
export type ShortcutMenuEmptySelectionRenderer = React.ComponentType<{
    mouseHandler: IShortcutMenuMouseHandler;
}>;
